<article class="pt-4 pb-12 px-6 md:px-12 lg:px-27 text-text-primary text-base">
    <header>
        <h1 class="h3-text my-2 text-center" i18n>About Horse Hop</h1>
    </header>
    
    <section>
        <h2 class="h4-text my-2" i18n>Our Story</h2>
        <p i18n>Horse Hop began in 2024 with a simple yet powerful idea: to make horse transportation easier, faster, and more affordable for everyone. Like many horse owners, we faced the frustration of booking entire trucks for a single horse and realised there had to be a smarter solution. Driven by this need, we created Horse Hop – a platform that connects horse owners to share transportation costs, reduce hassle, and build community.</p>
    </section>
    
    <section>
        <h2 class="h4-text my-2" i18n>Our Mission</h2>
        <p i18n>At Horse Hop, we believe that horse transportation should be accessible to all – no stress and time waste, no overspending. Our mission is to provide equestrians with a seamless, user-friendly, and cost-effective platform. We’re here to help you save time and money, and connect with fellow horse lovers along the way.</p>
    </section>

    <section>
        <h2 class="h4-text my-2" i18n>Safety and Reliability</h2>
        <p i18n>At Horse Hop, the safety and well-being of your horse are our top priorities. To ensure a reliable and secure experience:</p>
        <ul class="list-disc list-inside my-2 ml-4">
            <li i18n><strong>Mandatory Driver Verification:</strong> All drivers on our platform undergo mandatory verification, including document checks, to confirm their identity.</li>
            <li i18n><strong>Reviewed and Rated Drivers:</strong> Our platform allows you to review driver profiles, ratings, and feedback from other users, helping you make an informed choice.</li>
            <li i18n><strong>Transparency:</strong> You’ll have access to clear trip details and secure communication with drivers to discuss any specific needs for your horse.</li>
        </ul>
        <p i18n>By prioritizing safety and transparency, we give you peace of mind knowing that your horse is in trusted hands.</p>
    </section>

    <section>
        <h2 class="h4-text my-2" i18n>What Makes Us Different</h2>
        <ul class="list-disc list-inside my-2 ml-4">
            <li i18n><strong>Completely New Approach:</strong> We’re redefining horse transportation by enabling ride-sharing tailored for horses.</li>
            <li i18n><strong>Easy to Use:</strong> Our platform is designed for simplicity – from finding a ride to organizing the details, everything is just a few clicks away.</li>
            <li i18n><strong>Comfortable & Convenient:</strong> Whether you’re a driver or a rider, Horse Hop ensures smooth communication and organization.</li>
            <li i18n><strong>Fast & Reliable:</strong> Quickly find rides that suit your needs without the endless back-and-forth.</li>
            <li i18n><strong>Cost-Effective & Eco-Friendly:</strong> Sharing transport saves you money and reduces CO2 emissions.</li>
        </ul>
    </section>

    <section>
        <h2 class="h4-text my-2" i18n>How It Works</h2>
        <p i18n>Horse Hop connects you with professional drivers or other equestrians who need or offer horse transportation. On our platform, you can:</p>
        <ul class="list-disc list-inside my-2 ml-4">
            <li><strong i18n>Post your ride and share expenses with others.</strong></li>
            <li><strong i18n>Find available rides posted by users.</strong></li>
            <li><strong i18n>Offer professional transportation of horses.</strong></li>
            <li><strong i18n>Communicate and coordinate the trip effortlessly.</strong></li>
        </ul>
        <p i18n>By fostering these connections, we’re making horse transportation not just affordable but also a stress-free experience for everyone involved.</p>
    </section>

    <section>
        <h2 class="h4-text my-2" i18n>Contact Us</h2>
        <p i18n>We’d love to hear from you! Have questions, feedback, or need assistance? Reach out to us anytime:</p>
        <p i18n>Email: <a href="mailto:info@horsehop.eu" class="underline text-blue-600">info&#64;horsehop.eu</a></p>
        <p i18n>Feedback Page: <a routerLink="/feedback" class="underline text-blue-600">click here</a></p>
        <!-- <p>Instagram: <a href="https://www.instagram.com/horsehop.eu" target="_blank" class="underline text-blue-600">&#64;horsehop.eu</a></p> -->
    </section>

    <section class="my-4">
        <strong i18n>At Horse Hop, we’re here to make your journey as easy and smooth as possible – for you and your horse.</strong>
    </section>
</article>